export default "__VITE_ASSET__DEWS_Wz___"